import React, { Fragment, useEffect, useState } from 'react'
import Humberg from '../../elements/Humberg';
import { useDispatch, useSelector } from 'react-redux';
import LoaderBlock from '../loader/LoaderBlock';
import SingleOrderReport from './SingleOrderReport';
import DateFilter from '../../elements/DateFilter';

import Filters from './Filters';
import { allProductTypesAction, clearErrors } from '../../redux/actions/userActions';
import { UPDATE_REPORT_STATUS_RESET } from '../../redux/constants/orderConstants';
import { toast } from 'react-toastify';
import Loader from '../loader/loader';
import TopBarValues from './topBarValues';



/*************  ✨ Windsurf Command 🌟  *************/
const OrderReports = () => {



    const dispatch = useDispatch()


    const { loading,
        reports,
        totalPages,
        resolved_count,
        pending_count,
        rejected_count,
        under_review_count
    } = useSelector((state) => state.orderReports)

    const { user } = useSelector(state => state.verifyEmailStore);

    const { loading: updateReportLoading, error, message } = useSelector(state => state.createReport)





    const [page, setPage] = useState('1');
    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');
    const [target_user, setTarget_user] = useState('other');



    // Remove one quantity



    useEffect(() => {

        dispatch(allProductTypesAction())
        document.title = "Order Reports "

    }, [dispatch])



    useEffect(() => {
        if (message) {
            toast.success(message);
            dispatch({ type: UPDATE_REPORT_STATUS_RESET })
        }
        if (error) {
            toast.error(error);
            dispatch(clearErrors())
        }
    }, [message, error, dispatch])







    return (
        <Fragment>
            {updateReportLoading && <Loader />}
            <Humberg header="Dashboard" headerLink="/" children={"Order Reports"} />
            <DateFilter
                dateFrom={dateFrom}
                setDateFrom={setDateFrom}
                dateTo={dateTo}
                setDateTo={setDateTo}
            />
            <br />
            <TopBarValues
                resolved_count={resolved_count}
                pending_count={pending_count}
                rejected_count={rejected_count}
                under_review_count={under_review_count}

            />
            <section className="p-[1.5vmax] mt-[1vmax]" >

                <Filters page={page} setPage={setPage} dateFrom={dateFrom} dateTo={dateTo}
                    target_user={target_user}
                />
                
                <div className="bg-white p-[2vmax] lg:mt-[-2vmax]  shadow-1 rounded-b-lg overflow-x-auto lg:overflow-visible my-scroll-2 my-scroll-3">
                    {user?.role !== "SUPER_ADMIN" && user?.role !== "ADMIN" &&
                        <div className="flex-center gap-[1vmax] my-[2vmax]">
                            <button className={`text-[1.5vmax] lg:text-[1vmax] font-3 font-[700]   p-[0.3vmax_1vmax] rounded-lg ${target_user === 'other' ? "bg-[image:var(--gradient-2)] text-white" : "bg-blue-100 text-blue-500"} shadow-1`}
                                onClick={() => setTarget_user('other')}
                            >
                                Reports You Submitted
                            </button>
                            <button className={`text-[1.5vmax] lg:text-[1vmax] font-3 font-[700]   p-[0.3vmax_1vmax] rounded-lg ${target_user === "" ? "bg-[image:var(--gradient-2)] text-white" : "bg-blue-100 text-blue-500"} shadow-1`}
                                onClick={() => setTarget_user("")}
                            >
                                Reports Against You
                            </button>
                        </div>
                    }
                    
                    <div className="w-full overflow-auto lg:overflow-visible">
                        <div className="flex mt-[2vmax] w-[240%] lg:w-full bg-gray-200 py-[0.5vmax] items-center rounded-2xl border-l-[0.2vmax] border-transparent">
                            <div className="text-center flex-[0.5] min-w-[70px] flex-shrink-0 text-[#4c4c5c] uppercase text-[1.5vmax] lg:text-[0.8vmax]" >
                                Order ID
                            </div>
                            <div className="px-[0.5vmax] flex-[1.5] min-w-[150px] flex-shrink-0 text-[#4c4c5c] uppercase text-[1.5vmax] lg:text-[0.8vmax]" >
                                Report Type
                            </div>
                            <div className="text-center px-[0.5vmax] flex-[2] min-w-[220px] flex-shrink-0 text-[#4c4c5c] uppercase text-[1.5vmax] lg:text-[0.8vmax]" >
                                Reported By
                            </div>
                            <div className="text-center px-[0.5vmax] flex-[2] min-w-[220px] flex-shrink-0 text-[#4c4c5c] uppercase text-[1.5vmax] lg:text-[0.8vmax]" >
                                Reported Against
                            </div>
                            <div className="text-center px-[0.5vmax] flex-[1.5] min-w-[150px] flex-shrink-0 text-[#4c4c5c] uppercase text-[1.5vmax] lg:text-[0.8vmax]" >
                                Resolved By
                            </div>
                            <div className="text-center px-[0.5vmax] flex-[1] min-w-[120px] flex-shrink-0 text-[#4c4c5c] uppercase text-[1.5vmax] lg:text-[0.8vmax]" >
                                Reported On
                            </div>
                            <div className="text-center px-[0.5vmax] flex-[1] min-w-[120px] flex-shrink-0 text-[#4c4c5c] uppercase text-[1.5vmax] lg:text-[0.8vmax]" >
                                Status
                            </div>
                            <div className="text-center px-[0.5vmax] flex-[1.5] min-w-[160px] flex-shrink-0 text-[#4c4c5c] uppercase text-[1.5vmax] lg:text-[0.8vmax]" >
                                Actions
                            </div>
                        </div>
                        
                        {loading ?
                            <LoaderBlock />
                            :
                            reports?.length > 0 ?
                                reports.map((report, index) =>
                                    <SingleOrderReport key={report.id} order={report} user={user} />
                                )
                                :
                                <div className="text-center w-[240%] lg:w-full text-[1.5vmax] text-gray-400 py-[3vmax]" >
                                    No data found
                                </div>
                        }
                    </div>
                </div>
            </section>
            {totalPages > 1 && (
                <div className="flex gap-[1vmax] justify-center mt-[2vmax]">

                    {/* Prev button */}
                    <button
                        className="pagination-btn"
                        disabled={page === 1}
                        onClick={() => setPage(page - 1)}
                    >
                        Prev
                    </button>

                    {/* --- SMART PAGINATION START --- */}
                    {(() => {
                        const pages = [];
                        const maxVisible = 3; // number of pages to show around current page

                        const addPage = (p) => {
                            pages.push(
                                <button
                                    key={p}
                                    className={`pagination-btn ${page === p ? "active" : ""}`}
                                    onClick={() => setPage(p)}
                                >
                                    {p}
                                </button>
                            );
                        };

                        // Always show First Page
                        addPage(1);

                        // Left dots
                        if (page > maxVisible + 2) {
                            pages.push(<span key="dots-left">...</span>);
                        }

                        // Middle pages (dynamic)
                        for (
                            let p = Math.max(2, page - maxVisible);
                            p <= Math.min(totalPages - 1, page + maxVisible);
                            p++
                        ) {
                            addPage(p);
                        }

                        // Right dots
                        if (page < totalPages - (maxVisible + 1)) {
                            pages.push(<span key="dots-right">...</span>);
                        }

                        // Always show Last Page
                        if (totalPages > 1) {
                            addPage(totalPages);
                        }

                        return pages;
                    })()}
                    {/* --- SMART PAGINATION END --- */}

                    {/* Next button */}
                    <button
                        className="pagination-btn"
                        disabled={page === totalPages}
                        onClick={() => setPage(page + 1)}
                    >
                        Next
                    </button>

                </div>
            )}

            <br />
            <br />
            <br />
            <br />
        </Fragment>
    )
}

export default OrderReports